import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/drug-order-history";

export const pagingDrugOrderHistory = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);
